<template>
    <v-combobox
    ref="tagCombobox"
    v-model="rowTags"
    :items="storeState.allTags"
    chips
    label=""
    multiple
    single-line
    auto-select-first
    hide-selected
    :rules="tagRules"
    :search-input.sync="tagInput"
    append-icon=''
    dense
    :height="0"
    >
    <template v-slot:selection="{ attrs, item, select, selected }">
        <v-chip
        v-bind="attrs"
        :input-value="selected.text"
        close
        label
        @click="selectTag"
        @click:close="removeTag(item)"
        >
        {{ item.text }}
        </v-chip>
    </template>
    <template v-slot:no-data>
    </template>
    </v-combobox>
</template>

<script>
import Vue from 'vue';
import { store } from '../store.js';


export default {
  props: ['text', 'name', 'tags', 'row'],
  created() {
    // this.getUserData()
    // this.getFoodFacts();
    // this.renderUserEntries();
  },
  methods: {
    removeTag(item) {
      console.log('removetag: ', item, this.row)
      // this.storeState.editableDetails.tags.splice(this.storeState.editableDetails.tags.indexOf(item), 1)
      // this.storeState.editableDetails.tags = [...this.storeState.editableDetails.tags]
    },
    selectTag(item) {
      console.log('selectTag: ', item, this.row)
      console.log(item, this.row)
    },
    editComment(comment, e) {
      console.log('edit...', comment)
      this.storeState.currentFocus = 'editingComment'
      comment.disabled = false;
      this.storeState.editingComment = comment
    },
  },
  mounted() {
  },
  watch: {
    rowTags: {
        handler: function (val, oldVal) {
            console.log('watch rowTags', 'newval: ', val, '   oldVal:', oldVal)
            console.log('watch row', this.row)
            let detail_type = 'users'
            let details = this.storeState.editableDetailsAll[`${detail_type}-${this.row.email}`]
            details.tags = val
            store.updateEditableDetails(this.row.email, 'users', details)
        },
        deep: true
    }
  },
  filters: {
    dateFilter: function (date) {
      return moment(Number(date)).fromNow();
    }
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      tagInput: '',
      tagRules: [
        v => false
      ],
      rowTags: this.tags
    }
  }
};
</script>

<style>
.add-comment {
  margin-left: 10px;
}
.v-input__slot:before {
    border: none !important;
    border-color: rgba(255, 255, 255, 0.42) !important;
}
.v-input__slot:after {
    border: none !important;
    border-color: rgba(255, 255, 255, 0.42) !important;
}
</style> 